module.exports = __webpack_public_path__ + "media/old_images/default-image-generic-lighter-7920fba4.png";